// extracted by mini-css-extract-plugin
export default {"root":"_3kTOy","left":"_3cgB-","right":"_2SCmj"};